var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wapper"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"headerContent"},[_vm._v(_vm._s(_vm.name))]),_vm._t("back")],2),_c('div',{staticClass:"main"},[_vm._t("content")],2),_c('div',{staticClass:"bottom-left"}),_c('div',{staticClass:"bottom-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }